import { AuthenticationService } from './ats/authentication.service';


export const app_services = [AuthenticationService];

export * from './ats/authentication.service';


   